module.exports = __webpack_public_path__ + "lp/img/vote_bad_active.ca055fbd.svg";